/**
 * axios.js提供request请求封装
 * 包括 get、post、delete、put等方式
 * @author: ldy
 */

import axios from 'axios';
import { baseUrl } from '../config/env'
import { Toast, Notify } from 'vant';
// import { encrypt } from './crypto.js';
// import qs from 'qs';
// axios.defaults.withCredentials = true'
const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的服务。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};
const ajax = axios.create({
    baseURL: baseUrl, // url前缀
    timeout: 30000, // 超时毫秒数
    // withCredentials: true, // 携带认证信息cookie
});

// http request 请求拦截器，有token值则配置上token值
// ajax.interceptors.request.use(
//     config => {
//         //每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//         if (localStorage.getItem('accessToken')) {
//             config.headers.openId = localStorage.getItem('accessToken');
//         }
//         return config;
//     },
//     err => {
//         return Promise.reject(err);
//     });

// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
// ajax.interceptors.response.use(
//     response => {
//         // if (response.status == 200 || response.status == 201){
//         //   endload();
//         // }
//         return response;
//     },
//     error => {
//         if (error.response) {
//             console.log(error.response);
//             switch (error.response.status) {
//                 case 401:
//                     // 返回 401 清除token信息并跳转到登录页面
//                     localStorage.removeItem('accessToken');
//                     this.$router.push('/login');
//             }
//         }
//         return Promise.reject(error.response.data)  //返回接口返回的错误信息
//     });

/**
 * get方式请求，url传参
 * @param url 请求url
 * @param params 参数
 * @param level 0:无加密，1：参数加密，2: 签名+时间戳； 默认0
 */
const get = (url, params, level, showToast) => ajax(getConfig(url, 'get', true, params, level)).then(res => successback(res, showToast)).catch(error => errback(error));

/**
 * post方式请求 json方式传参
 * @param url 请求url
 * @param params 参数
 * @param level 0:无加密，1：参数加密，2: 签名+时间戳； 默认0
 */
const postJson = (url, params, level) => ajax(getConfig(url, 'post', true, params, level)).then(res => successback(res)).catch(error => errback(error));

/**
 * post方式请求 表单传参
 * @param url 请求url
 * @param params 参数
 * @param level 0:无加密，1：参数加密，2: 签名+时间戳； 默认0
 */
const post = (url, params, level, showToast) => ajax(getConfig(url, 'post', false, params, level)).then(res => successback(res, showToast)).catch(error => errback(error));

/**
 * delete方式请求 url传参
 * @param url 请求url
 * @param params 参数
 * @param level 0:无加密，1：参数加密，2: 签名+时间戳； 默认0
 */
const del = (url, params, level) => ajax(getConfig(url, 'delete', true, params, level)).then(res => successback(res)).catch(error => errback(error));

/**
 * put方式请求 json传参
 * @param url 请求url
 * @param params 参数
 * @param level 0:无加密，1：参数加密，2: 签名+时间戳； 默认0
 */
const putJson = (url, params, level) => ajax(getConfig(url, 'put', true, params, level)).then(res => successback(res)).catch(error => errback(error));

/**
 * put方式请求 表单传参
 * @param url 请求url
 * @param params 参数
 * @param level 0:无加密，1：参数加密，2: 签名+时间戳； 默认0
 */
const put = (url, params, level) => ajax(getConfig(url, 'put', false, params, level)).then(res => successback(res)).catch(error => errback(error));

// 参数转换
// const param2String = data => {
//     if (typeof data === 'string') {
//         return data;
//     }
//     let ret = '';
//     for (let it in data) {
//         let val = data[it];
//         if (typeof val === 'object' && (!(val instanceof Array) || (val.length > 0 && (typeof val[0] === 'object')))) {
//             val = JSON.stringify(val);
//         }
//         ret += it + '=' + encodeURIComponent(val) + '&';
//     }
//     if (ret.length > 0) {
//         ret = ret.substring(0, ret.length - 1);
//     }
//     return ret;
// };

// 错误回调函数
const errback = error => {
    if (error) {
        let msg = ''
        const { response } = error
        if (response && response.status) {
            msg = codeMessage[response.status] || response.statusText;
        } else {
            msg = error.message
        }
        // if (typeof error.message == 'string') {
        //   msg = error.message
        // } else {
        //   msg = error.msg
        // }
        setTimeout(() => {
            Toast.clear();
        }, 1000);
        Notify({
            type: 'danger',
            message: msg,
            duration: 3000
        });
        // localStorage.removeItem('accessToken');
        // this.$router.push('/login');
        return Promise.reject(null);
    }
};

// 成功回调函数
const successback = (res, showToast = true) => {
    if (res.status === 200 && res.data.code === 200) {
        setTimeout(() => {
            Toast.clear();
        }, 1000);
        return res.data;
    } else if (res.status === 200 && res.data.code !== 200) {
        if (res.data.msg) {
            showToast && Toast({
                position: 'top',
                message: res.data.msg,
                duration: 1000
            });
            setTimeout(() => {
                Toast.clear();
            }, 1000);
            return Promise.reject(null);
        } else {
            setTimeout(() => {
                Toast.clear();
            }, 1000);
            return Promise.reject(res.data);
        }
    } else {
        setTimeout(() => {
            Toast.clear();
        }, 1000);
        return Promise.reject(res.data);
    }
};

/**
 * @param url 请求url
 * @param method get,post,put,delete
 * @param isjson 是否json提交参数
 * @param params 参数
 * @param level 0:无加密，1：参数加密，2: 签名+时间戳； 默认0
 */
const getConfig = (url, method, isjson, params = 0) => {
    // console.log(url, method,isjson, params, level)
    Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0
    });
    let config_ = {
        url,
        method,
        headers: {}
    };
    // 表单提交参数
    if (!isjson) {
        config_.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config_.responseType = 'text';
        // config_.transformRequest = [function (data) {
        //   return param2String(data);
        // }];
    }
    // 设置参数
    if (method in { 'get': true, 'delete': true }) {
        // let timestamp = new Date().getTime();
        // params['timestamp'] = timestamp;
        // params['signature'] = encrypt(timestamp);
        // params['timestamp'] = "1234567890";
        // params['signature'] = "48A30384874675EB50C57828223363D0";
        config_.params = params;
    } else if (method in { 'post': true, 'put': true }) {
        config_.headers['Content-Type'] = 'application/json;charset=UTF-8';
        config_.data = JSON.stringify(params);
    }
    return config_;
};

// 统一方法输出口
export {
    ajax,
    get,
    postJson,
    post,
    del,
    putJson,
    put
};